import React from "react";
import { useTranslation } from "react-i18next";
import { Account } from "@rentablo/api/apiv1";
import { Theme, useMediaQuery, useTheme } from "@mui/material";
import { BOTTOM_SHEET_Z_INDEX, Modal, ModalProps } from "@rentablo/components";
import { DepotsSelectorBody } from "./DepotsSelectorBody";

type Props = {
  accounts?: Account[];
  onConfirm: (ids: number[]) => void;
  onSelect: (ids: number[]) => void;
  checkedPortfolios: number[];
} & Omit<ModalProps, "children">;

export const DepotsSelectorModal = ({
  accounts,
  checkedPortfolios = [],
  onSelect,
  onConfirm,
  onClose,
  ...rest
}: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isSm = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  const handleConfirm = () => {
    onConfirm(checkedPortfolios);
    onClose?.();
  };

  return (
    <Modal
      title={t("depotsSelect.title")}
      onClose={onClose}
      height="auto"
      disablePortal={false}
      {...(isSm && {
        position: "bottom" as const,
        width: "100%",
        height: "fit-content",
        zIndex: BOTTOM_SHEET_Z_INDEX,
        contentPadding: theme.spacing(4, 4, 0),
        titleMargin: 2,
      })}
      {...rest}
    >
      <DepotsSelectorBody
        accounts={accounts}
        checkedPortfolios={checkedPortfolios}
        onSelect={onSelect}
        onConfirm={handleConfirm}
        onClose={onClose}
      />
    </Modal>
  );
};
